import { useContext, useState } from 'react';
import { Chip } from '@mui/material';
import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';
import { ScribanExprPopover } from './ScribanExprPopover';
import { ScribanPaletteContext } from './scribanPaletteContext';

/**
 * NodeView for the atomic `scribanExpr` node: renders `{{ expr }}` as a locked chip.
 * The expression is never edited as free text — only through the popover.
 */
export function ScribanExprChipView({ node, selected, updateAttributes, deleteNode, editor }: NodeViewProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const options = useContext(ScribanPaletteContext);
  const expr = String(node.attrs.expr ?? '');

  return (
    <NodeViewWrapper as="span" style={{ display: 'inline' }}>
      <Chip
        label={`⟨${expr}⟩`}
        size="small"
        variant="outlined"
        color={selected ? 'primary' : 'default'}
        onClick={(event) => {
          if (editor.isEditable) setAnchorEl(event.currentTarget);
        }}
        sx={{ height: 20, fontFamily: 'monospace', fontSize: 11, cursor: 'pointer', verticalAlign: 'baseline' }}
      />
      <ScribanExprPopover
        anchorEl={anchorEl}
        expr={expr}
        options={options}
        onClose={() => setAnchorEl(null)}
        onSave={(next) => {
          setAnchorEl(null);
          updateAttributes({ expr: next });
        }}
        onRemove={() => {
          setAnchorEl(null);
          deleteNode();
        }}
      />
    </NodeViewWrapper>
  );
}
